<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-card v-if="list_access || 1 == 1">
        <div class="row mb-2 mt-0">
          <div class="col-md-12">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="from_selected"
                    v-model="from_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="from_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="from_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="from_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="from_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.from_selected.save(from_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="to_selected"
                    v-model="to_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="to_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="to_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="to_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="to_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.to_selected.save(to_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Empresa" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col-md-4"></div>
                <div class="col-md-2 pt-0 d-flex justify-end">
                  <v-btn color="info" class="" @click="filter">Generar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <v-card v-if="list_access || 1 == 1">        

        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td style="text-transform: capitalize">{{ props.item.categoria_impuesto }}</td>
              <td class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="green" class="mr-2" @click="exportFile(props.item)">mdi-download</v-icon>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>
              </td>

   
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { reportService } from "@/libs/ws/reportService";
import { impuestosService } from "@/libs/ws/impuestosService";
import { formatUtils } from "@/libs/utils/formatUtils";

import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { emmiterService } from "@/libs/ws/emmiterService";

export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, ExportMixin, SettingsMixin],
  data() {
    return {
      Constant: Constant,
      formatUtils: formatUtils,
      service: impuestosService,
      page_title: "Agentes de Recaudacion",
      modal_title: "Agentes de Recaudacion",
      headers: [        
        { text: "Impuesto", value: "name" },
        { text: "Tipo", value: "categoria_impuesto" },
        { text: "Accion",  align: "right" },
      ],
      list: [],
      from_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      from_selected_open: false,
      to_selected: new Date().toISOString().slice(0, 10),
      to_selected_open: false,
      emitter_selected: null,
      emitters: [],
      total: 0,
    };
  },
  mounted() {
    this.loadEmitters();
  },
  methods: {
    getFilterParams() {
      const param = {
        from: this.from_selected,
        to: this.to_selected,
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
      };
      return param;
    },
    loadEmitters() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result;

        if(this.emitters.length == 1){
          this.emitter_selected = this.emitters[0];
          this.loadList(this.service, this.getFilterParams());
        }
      });
    },
    filter() {
      if (!this.from_selected || !this.to_selected) {
        this.$toast.error("Debe seleccionar ambas fechas (Desde y Hasta).");
        return;
      }
      if (this.from_selected > this.to_selected) {
        this.$toast.error("La fecha Desde no puede ser mayor a la fecha Hasta.");
        return;
      }
      this.loadList(this.service, this.getFilterParams());
    },
    getTotal() {
      this.total = 0;
      if (this.list.length > 0) {
        this.list.forEach((element) => {
          this.total = (parseFloat(this.total) + parseFloat(element.importe)).toFixed(2);
        });
      }
    },
    loadList(service, param = null) {
      if (param == null) {
        param = this.getFilterParams();
      }
      this.loading = true;

      this.open_filter = false;
      service
        .getAgenteRecaudacionImpuestos(param)
        .then((response) => {
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
          this.getTotal();
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.total = 0;
          this.loading = false;
        });
    },
    exportFile(item) {
      var param = this.getFilterParams();
      param["export"] = true;
      param["impuesto"] = item.id;
      console.log("Exportando con parametros: ", param);
      //exportExcel(path, params, file_name) {
      this.exportExcel(Constant.SECTION_REPORT_AGENTES_RECAUDACION, param, "AgentesRecaudacion-" + this.from_selected + "_" + this.to_selected + "-" + item.name + ".txt");
    },
  },
};
</script>
